import { render } from "./NavigationPhoneArrowIcon.vue?vue&type=template&id=57ddf45f"
import script from "./NavigationPhoneArrowIcon.vue?vue&type=script&lang=js"
export * from "./NavigationPhoneArrowIcon.vue?vue&type=script&lang=js"

import "./NavigationPhoneArrowIcon.vue?vue&type=style&index=0&id=57ddf45f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__